import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { BANK_ICON_OPTIONS, DEFAULT_BANK_ICON_ID, resolveBankIcon } from "../assets/banks/bankIcons";
import { cn } from "../lib/utils";
import { BankIcon } from "./BankIcon";
import { Button } from "./ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Label } from "./ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function BankIconPicker({ value, bankName, onSelect, disabled = false }) {
  const [open, setOpen] = useState(false);
  const selectedIcon = resolveBankIcon(value, bankName);

  const handleSelect = (icon) => {
    const nextValue = icon.id === DEFAULT_BANK_ICON_ID ? null : icon.id;
    onSelect?.(nextValue, icon);
    setOpen(false);
  };

  return (
    <div className="space-y-2">
      <Label>Ícone do Banco</Label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="outline"
            role="combobox"
            aria-expanded={open}
            disabled={disabled}
            className="h-auto min-h-11 w-full justify-between px-3"
          >
            <span className="flex min-w-0 items-center gap-3 text-left">
              <BankIcon iconId={value} bankName={bankName} size="sm" />
              <span className="truncate font-normal">{selectedIcon.label}</span>
            </span>
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[min(92vw,440px)] p-0" align="start">
          <Command>
            <CommandInput placeholder="Buscar banco..." />
            <CommandList className="max-h-[min(58vh,360px)]">
              <CommandEmpty>Nenhum banco encontrado.</CommandEmpty>
              <CommandGroup className="p-2">
                <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
                  {BANK_ICON_OPTIONS.map((icon) => {
                    const isSelected = selectedIcon.id === icon.id;
                    return (
                      <CommandItem
                        key={icon.id}
                        value={[icon.label, icon.id, ...icon.aliases].join(" ")}
                        onSelect={() => handleSelect(icon)}
                        className={cn(
                          "relative flex h-[76px] min-w-0 flex-col items-center justify-center gap-1 rounded-md border border-transparent px-2 py-2 text-center",
                          "data-[selected=true]:bg-muted",
                          isSelected && "border-primary bg-primary/10 text-primary"
                        )}
                      >
                        <BankIcon iconId={icon.id} size="sm" />
                        <span className="block w-full truncate text-xs leading-tight">{icon.label}</span>
                        <Check className={cn("absolute right-1.5 top-1.5 h-3.5 w-3.5", isSelected ? "opacity-100" : "opacity-0")} />
                      </CommandItem>
                    );
                  })}
                </div>
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
